import TextField from "@mui/material/TextField";

function Input(props) {
  const { label, register, options, ...defaultProps } = props;
  const { name } = defaultProps;

  return (
    <div>
      <TextField
        label={label}
        {...register(name, options)}
        {...defaultProps}
        variant="filled"
      />
    </div>
  );
}

export default Input;
